import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface adminLevelInitialSliceI {
  totalPages: number;
  totalRecords: number;
}

const initialState: adminLevelInitialSliceI = {
  totalPages: 0,
  totalRecords: 0
};

export const adminLevelSlice = createSlice({
  name: 'adminLevelSlice',
  initialState,
  reducers: {
    setAdminLevelTotalPages: (
      state: adminLevelInitialSliceI,
      actions: PayloadAction<adminLevelInitialSliceI>
    ) => {
      state.totalPages = actions.payload.totalPages;
      state.totalRecords = actions.payload.totalRecords;
    }
  }
});
